// src/Routes/event/sns-promotion/page.tsx
import React, { useState } from "react";
import BACK_IMG from "../../../components/common/back-img.png";
import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import { useNavigate } from "react-router-dom";

const SnsPromotion: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<"mamcafe" | "blog">("mamcafe");

  return (
    <div className="flex flex-col items-center w-full h-full bg-gray-50">
      <img
        src={BACK_IMG}
        onClick={() => {
          if (window.history.length <= 1) {
            navigate("/");
          } else {
            navigate(-1);
          }
        }}
        className="absolute top-5 left-5 w-[40px] h-[40px] z-10"
        alt="back"
      />

      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-4 pt-8">
        {/* 헤더 영역 */}
        <div className="text-center mb-6">
          <h1 className="text-4xl text-blue-600 font-extrabold mb-2">
            후기 쓰고 바로 <br />
            3,000원 쿠폰 받기 🎁
          </h1>
          <p className="text-gray-600 text-lg">
            마감히어로 후기 공유하고 혜택을 받아보세요!
          </p>
        </div>

        {/* 참여 혜택 안내 */}
        <section className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            🎉 참여 혜택
          </h2>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="flex items-center justify-center mb-3">
              <span className="text-3xl font-bold text-blue-600">3,000원</span>
              <span className="text-lg text-gray-600 ml-2">
                쿠폰 즉시 지급!
              </span>
            </div>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• 유효기간: 무제한</li>
              <li>• 최소주문금액: 5,000원 이상</li>
              <li>• 중복 사용 불가 (1인 1회)</li>
            </ul>
          </div>
        </section>

        {/* 참여 방법 안내 */}
        <section className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            📱 참여 방법
          </h2>

          {/* 탭 메뉴 */}
          <div className="flex flex-wrap bg-gray-100 rounded-lg p-1 mb-4 gap-1">
            <button
              onClick={() => setActiveTab("mamcafe")}
              className={`flex-1 min-w-[80px] py-2 px-2 rounded-md text-xs font-medium transition-colors ${
                activeTab === "mamcafe"
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              맘카페
            </button>
            <button
              onClick={() => setActiveTab("blog")}
              className={`flex-1 min-w-[80px] py-2 px-2 rounded-md text-xs font-medium transition-colors ${
                activeTab === "blog"
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              블로그
            </button>
          </div>

          {/* 탭 내용 */}
          <div className="bg-white rounded-lg p-4 border">
            {activeTab === "mamcafe" && (
              <div>
                <h3 className="font-bold text-lg mb-3 text-green-600">
                  👶 맘카페(1,000원) 참여 방법
                </h3>
                <ol className="list-decimal list-inside space-y-2 text-sm">
                  <li>맘카페에 마감히어로 후기 게시물 작성</li>
                  <li>카카오채널로 링크와 캡처본을 인증!</li>
                </ol>
                <div className="mt-3 p-3 bg-green-50 rounded-lg">
                  <p className="text-xs text-green-700">
                    💡 인증시, 카페명 함께 기재해 주세요.
                  </p>
                </div>
              </div>
            )}

            {activeTab === "blog" && (
              <div>
                <h3 className="font-bold text-lg mb-3 text-orange-600">
                  📝 블로그(3,000원) 참여 방법
                </h3>
                <ol className="list-decimal list-inside space-y-2 text-sm">
                  <li>마감히어로 후기를 블로그에 게시</li>
                  <li>카카오채널로 링크와 캡처본을 인증!</li>
                </ol>
                <div className="mt-3 p-3 bg-orange-50 rounded-lg">
                  <p className="text-xs text-orange-700 font-semibold mb-2">
                    💡 제목에 들어갈 핵심 키워드
                  </p>
                  <div className="bg-white p-3 rounded border border-orange-200 text-xs text-gray-700">
                    <p>마감히어로 / 매장명 / 지역명 / 빵켓팅 / oo 맛집 / oo 카페 / oo 빵집 / 베이커리</p>
                  </div>
                </div>
              </div>
            )}

          </div>
        </section>

        {/* 쿠폰 지급 안내 */}
        <section className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            🎫 쿠폰 지급 안내
          </h2>
          <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-lg p-4">
            <ul className="text-sm space-y-2">
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✓</span>운영 팀 확인 후 앱
                내 쿠폰함에 자동으로 지급됩니다
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✓</span>
                푸시 알림으로 확인 가능합니다
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✓</span>
                마이페이지 {">"} 쿠폰함에서 확인하세요
              </li>
            </ul>
          </div>
        </section>

        {/* FAQ / 유의사항 */}
        <section className="mb-48">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            ❓ FAQ / 유의사항
          </h2>
          <div className="bg-white rounded-lg p-4 border space-y-3">
            <div className="border-l-4 border-red-200 pl-3">
              <p className="font-medium text-red-800">중복 참여 불가</p>
              <p className="text-xs text-gray-600">
                1인당 1회만 참여 가능합니다
              </p>
            </div>
            <div className="border-l-4 border-orange-200 pl-3">
              <p className="font-medium text-orange-800">허위/삭제된 후기</p>
              <p className="text-xs text-gray-600">
                발견 시 쿠폰이 회수될 수 있습니다
              </p>
            </div>
            <div className="border-l-4 border-yellow-200 pl-3">
              <p className="font-medium text-yellow-800">부적절한 후기</p>
              <p className="text-xs text-gray-600">
                운영진 판단에 따라 제외될 수 있습니다
              </p>
            </div>
            <div className="border-l-4 border-blue-200 pl-3">
              <p className="font-medium text-blue-800">쿠폰 사용 조건</p>
              <p className="text-xs text-gray-600">
                최소 주문금액 5,000원 이상
              </p>
            </div>
          </div>
        </section>

        {/* 문의/고객센터 연결 */}
        <FadeInWrapper className="inline w-full mt-4 fixed bottom-0 left-0 right-0 p-4">
          <div className="bg-white rounded-lg shadow-lg p-4 mb-4">
            <h3 className="font-bold text-gray-800 mb-2 text-center">
              문의하기
            </h3>
            <p className="text-sm text-gray-600 text-center mb-3">
              문제가 발생하거나 궁금한 점이 있으시면 언제든 문의해주세요!
            </p>
            <button
              className="w-full py-3 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-colors"
              onClick={() =>
                window.open("http://pf.kakao.com/_xawxcRn/chat", "_blank")
              }
            >
              카카오톡 문의 💬
            </button>
          </div>
        </FadeInWrapper>
      </div>
    </div>
  );
};

export default SnsPromotion;
